import { FIFA_LOGO_URL } from "../../constants";
import Style from "./NotFound.module.scss";

const NotFound = (): JSX.Element => {
  return (
    <div className="container">
      <img src={FIFA_LOGO_URL} alt="FIFA Logo" className={Style.FifaLogo} />
      <div className={Style.NotFoundContainer}>
        <div className={Style.Text}>
          <p>Welcome to FIFA Embeddable Player.</p>
          <p>
            If you see this screen, please make sure you input correct partner
            name in the URL
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
